import { Grid, Tab } from '@material-ui/core';
import { Notifications } from '@material-ui/icons';
import LinkIcon from '@material-ui/icons/Link';
import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import { getNotifications } from '@webapps/business';
import {
  Pagination,
  PaginationNumbers,
  useAuth,
  useQuery,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import CardNotification from 'components/Notification/cardNotification';
import notificationData from 'components/Notification/NotificationData';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

const NotificationsStudent = () => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const { idUser } = useAuth();
  const [page, setPage] = useState(1);
  const [pageRead, setPageRead] = useState(1);

  const [value, setValue] = useState('1');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const intl = useIntl();

  const {
    data: { content: notifs = [], totalElements } = {},
    refetch: refetchUnRead,
  } = useQuery(getNotifications, {
    key: ['notifsStudent', page + idUser],
    variables: {
      id: idUser,
      page: page - 1,
      size: 4,
      status: 'unread',
    },
    keepPreviousData: true,
    staleTime: 5000,
  });

  const {
    data: { content: notifsRead = [], totalElements: totalElementsRead } = {},
    refetch: refetchRead,
  } = useQuery(getNotifications, {
    key: ['notifsStudentRead', pageRead + idUser],
    variables: {
      id: idUser,
      page: pageRead - 1,
      size: 4,
      status: 'read',
    },
    keepPreviousData: true,
    staleTime: 5000,
  });

  const handlePaginationChange = (newPage) => {
    setPage(newPage);
  };

  const handlePaginationChangeRead = (newPage) => {
    setPageRead(newPage);
  };

  return (
    <div className={global.container}>
      <div className={classes.paper} square>
        <TabContext value={value}>
          <TabList indicatorColor="default" onChange={handleChange}>
            <Tab
              classes={{
                root: css({
                  border: '1px solid #C0D9FF',
                  borderBottom: 0,
                  borderTopLeftRadius: 5,
                  opacity: 1,
                  borderTopRightRadius: 5,
                  background: value === '1' ? 'white' : '#F3F7FF',
                  color: value === '1' ? '#152652' : '#5A6DA1',
                  fontWeight: value === '1' ? 600 : 400,
                  '@media only screen and (max-width:768px)': { width: '50%' },
                }),
              }}
              className={global.mainTitle}
              label={intl.formatMessage({
                id: 'Non lues',
              })}
              value="1"
            />
            <Tab
              classes={{
                root: css({
                  border: '1px solid #C0D9FF',
                  borderBottom: 0,
                  borderTopLeftRadius: 5,
                  opacity: 1,
                  borderTopRightRadius: 5,
                  background: value === '2' ? 'white' : '#F3F7FF',
                  color: value === '2' ? '#152652' : '#5A6DA1',
                  fontWeight: value === '2' ? 600 : 400,
                  '@media only screen and (max-width:768px)': { width: '50%' },
                }),
              }}
              className={global.mainTitle}
              label={intl.formatMessage({
                id: 'Lues',
              })}
              value="2"
            />
          </TabList>

          <TabPanel
            className={css({
              background: 'white',
              borderRadius: '0 10px 10px 10px',
              padding: spacing(2.5),
              '@media only screen and (max-width:768px)': {
                borderRadius: '0 0px 10px 10px',
              },
            })}
            value="1"
          >
            <Grid
              container
              style={
                notifs.length === 0
                  ? {
                    display: 'flex',
                    justifyContent: 'center',
                    padding: spacing(2.5),
                    backgroundColor: '#F3F7FF',
                    borderRadius: 10,
                  }
                  : {
                    display: 'flex',
                    backgroundColor: '#F3F7FF',
                    borderRadius: 10,
                    padding: spacing(2.5, 0, 0, 2.5),
                  }
              }
            >
              {notifs.length === 0 ? (
                <div
                  className={css({
                    color: '#5D75A8',
                  })}
                >
                  <FormattedMessage id="Aucune notification" />
                </div>
              ) : (
                <>
                  {notifs.map(({ attributes, date, id, type }) => (
                    <Grid className={classes.cardContainer} item xs={12} md={6}>
                      <CardNotification
                        date={date}
                        icon={LinkIcon}
                        id={id}
                        notifData={notificationData(
                          intl,
                          type,
                          attributes,
                          'student',
                          date
                        )}
                      />
                    </Grid>
                  ))}
                </>
              )}
            </Grid>
            <PaginationNumbers
              onChange={handlePaginationChange}
              page={page}
              pageCount={4}
              totalCount={totalElements}
            />
          </TabPanel>
          <TabPanel
            className={css({
              background: 'white',
              borderRadius: '0 10px 10px 10px',
              padding: spacing(2.5),
              '@media only screen and (max-width:768px)': {
                borderRadius: '0 0px 10px 10px',
              },
            })}
            value="2"
          >
            <Grid
              container
              style={
                notifsRead.length === 0
                  ? {
                    display: 'flex',
                    justifyContent: 'center',
                    padding: spacing(2.5),
                    backgroundColor: '#F3F7FF',
                    borderRadius: 10,
                  }
                  : {
                    display: 'flex',
                    backgroundColor: '#F3F7FF',
                    borderRadius: 10,
                    padding: spacing(2.5, 0, 0, 2.5),
                  }
              }
            >
              {notifsRead.length === 0 ? (
                <div
                  className={css({
                    textAlign: 'center',
                    marginTop: spacing(2.5),
                    color: '#5D75A8',
                  })}
                >
                  <FormattedMessage id="Aucune notification" />
                </div>
              ) : (
                <>
                  {notifsRead.map(({ attributes, date, id, type }) => (
                    <Grid className={classes.cardContainer} item xs={12} md={6}>
                      <CardNotification
                        date={date}
                        icon={LinkIcon}
                        id={id}
                        notifData={notificationData(
                          intl,
                          type,
                          attributes,
                          'student',
                          date
                        )}
                      />
                    </Grid>
                  ))}
                </>
              )}
            </Grid>
            <PaginationNumbers
              onChange={handlePaginationChangeRead}
              page={pageRead}
              pageCount={4}
              totalCount={totalElementsRead}
            />
          </TabPanel>
        </TabContext>
      </div>
    </div>
  );
};

const styles = ({ spacing }) => ({
  paper: {
    flex: '1 1 0px',
    borderRadius: 10,

    // background,
  },
  cardInformation: {
    padding: spacing(2),
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    borderBottom: '0px solid',
    display: 'flex',
    columnGap: spacing(2),
  },
  firstIconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 65,
    width: 65,
    backgroundColor: '#DAE9FC',
    borderRadius: 100,
    '& > *': {
      height: 35,
      width: 35,
      color: '#0060F9',
    },
  },
  text: {
    color: '#152652',
    lineHeight: '110%',

    marginTop: spacing(1),
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    columnGap: spacing(1),

    marginTop: spacing(1),
  },
  cardSeeMore: {
    padding: spacing(2),
    borderRadius: 0,
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    border: '1px solid #E8E8E8',
    borderTop: '2px solid #C0D9FF',

    textAlign: 'center',
  },
});
export default NotificationsStudent;
